import WALL_API from './wallChannel'

const baseImagesUrl = 'https://assetsl1lco.nixi1.dkv.es/chatweb/images/'
const baseSoundsUrl = 'https://assetsl1lco.nixi1.dkv.es/chatweb/sounds/'

export {
  WALL_API,
  baseImagesUrl,
  baseSoundsUrl
}
